import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';
import { CaseLogType } from '../../cases/_types/case-log-type';
import { LoginService } from '../../login/login.service';
import { Dataset } from '../../reports/_types/dataset';
import { DatasetsService } from '../../reports/_services/datasets.service';

@Component({
    selector: 'app-datasets-list',
    templateUrl: './datasets-list.component.html',
    styleUrls: ['./datasets-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class DatasetsListComponent {
  public datasets: Dataset[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private datasetsService: DatasetsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Conjuntos de datos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseLogType);
    });
    this.allowWrite = true; //this.loginService.hasPermission("DATASETS.WRITE")
    this.allowDelete = true; //this.loginService.hasPermission("DATASETS.DELETE")
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.datasetsService.all(params));
    this.datasets = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseState: CaseLogType) {
    this.router.navigate(['datasets/' + (caseState && Object.keys(caseState).length > 0 ? caseState.id : 0)]);
  }

  delete(caseState: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el registro?",
        header: "Eliminar registro",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.datasetsService.delete(caseState.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Registro eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

  snapshot(dataset: Dataset) {
    this.datasetsService.snapshot(dataset.id!).subscribe({
      next: (data: any) => {
        this.messageService.add({ closable: true, severity: 'success', detail: "Snapshot ejecutado correctamente" });
        this.loadData(this.lastGridEvent);
      },
      error: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: "Error ejecutando el snapshot" });
      }
    });
  }

  formatDuration(duration: string): string {
    if (!duration) return '';
    const parts = duration.split(':');
    const h = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const s = Math.floor(parseFloat(parts[2]));
    const result = [];
    if (h > 0) result.push(h + 'h');
    if (m > 0) result.push(m + 'm');
    result.push(s + 's');
    return result.join(' ');
  }
}
